import { useLocale } from '@mirai/locale';
import { Notification, Progress, styles, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';

import { SCRIPT_ID, SCRIPT_URL } from './FormGetnet.constants';
import { L10N } from './FormGetnet.l10n';
import * as style from './FormGetnet.module.css';
import { loadScript } from '../../../../../helpers/loadScript';

export const FormGetnet = ({ response, ...others }) => {
  const { translate } = useLocale();

  const [error, setError] = useState();
  const [ready, setReady] = useState(false);
  const [paymentReady, setPaymentReady] = useState(false);

  const ref = useRef();

  useEffect(() => {
    let mounted = true;
    let cleanup;

    (async () => {
      try {
        cleanup = await loadScript({
          async: true,
          'data-testid': SCRIPT_ID,
          domain: 'payments',
          id: SCRIPT_ID,
          src: SCRIPT_URL,
          onLoad: () => setReady(true),
        });
        if (mounted && window.checkout) setReady(true);
      } catch (nextError) {
        setError(nextError);
      }
    })();

    return () => {
      mounted = false;
      cleanup && cleanup();
    };
  }, []);

  useEffect(() => {
    if (!ready || !response) return;

    const { configuration: { paymentIntentId } = {} } = response || {};

    try {
      setError();
      setPaymentReady(false);
      window.loader.init({ checkoutType: 'iframe', paymentIntentId });
      const iframe = document.querySelector('#digital-checkout-iframe');
      ref.current.appendChild(iframe);
      setPaymentReady(true);
    } catch (nextError) {
      setError(nextError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready, response]);

  return (
    <View {...others} className={styles(others.className, style.container)}>
      <Progress indeterminate visible={!paymentReady && !error} />
      <View ref={ref} className={style.checkout} />
      {error && (
        <Notification error small wide>
          {translate(L10N.NOTIFICATION_ERROR)}
        </Notification>
      )}
    </View>
  );
};

FormGetnet.displayName = 'Mirai:Payments:ButtonPayment:FormGetnet';

FormGetnet.propTypes = {
  response: PropTypes.shape({}),
};
